import videocallshopApi from '../apis/videocallshop';

import { toastr } from 'react-redux-toastr';

import {
    getCustomerSession,
    saveCustomerSession,
    updateCustomerSession,
    clearCustomerSession,
} from '../apis/customerSession';

import {
    CUSTOMER_LOGIN_REQUESTED,
    CUSTOMER_LOGIN_SUCCESS,
    CUSTOMER_LOGIN_FAILED,
    CUSTOMER_LOGOUT,
    CUSTOMER_ME_SUCCESS,
    CUSTOMER_CALL_REQUESTS_FETCH_REQUESTED,
    CUSTOMER_CALL_REQUESTS_FETCH_SUCCESS,
    CUSTOMER_CALL_REQUESTS_FETCH_FAILED,
    CUSTOMER_PURCHASE_ORDERS_FETCH_REQUESTED,
    CUSTOMER_PURCHASE_ORDERS_FETCH_SUCCESS,
    CUSTOMER_PURCHASE_ORDERS_FETCH_FAILED,
} from './types';

const loginSuccess = (dispatch, data) => {
    const { customer, accessToken, refreshToken } = data;

    saveCustomerSession({ accessToken, refreshToken, customer });

    dispatch({
        type: CUSTOMER_LOGIN_SUCCESS,
        payload: customer,
    });
};

// Login
export const loginWithGoogle = (idToken) => async (dispatch) => {
    dispatch({ type: CUSTOMER_LOGIN_REQUESTED });

    try {
        const { data } = await videocallshopApi.post('/auth/customer/google', {
            idToken,
        });

        loginSuccess(dispatch, data.data);
    } catch (err) {
        dispatch({ type: CUSTOMER_LOGIN_FAILED });
        toastr.error('Error', 'No se pudo iniciar sesión con Google.');
    }
};

export const loginWithApple = ({
    identityToken,
    authorizationCode,
    fullName,
}) => async (dispatch) => {
    dispatch({ type: CUSTOMER_LOGIN_REQUESTED });

    try {
        const { data } = await videocallshopApi.post('/auth/customer/apple', {
            identityToken,
            authorizationCode,
            fullName,
        });

        loginSuccess(dispatch, data.data);
    } catch (err) {
        dispatch({ type: CUSTOMER_LOGIN_FAILED });
        toastr.error('Error', 'No se pudo iniciar sesión con Apple.');
    }
};

// Silent boot: hydrate from storage, then refresh the profile in background.
// A dead session is handled by the axios interceptor (clears storage and
// fires SESSION_EXPIRED_EVENT, which App.js turns into customerSessionExpired).
export const bootstrapCustomer = () => async (dispatch) => {
    const session = getCustomerSession();
    if (!session || !session.customer) {
        return;
    }

    dispatch({
        type: CUSTOMER_LOGIN_SUCCESS,
        payload: session.customer,
    });

    try {
        const { data } = await videocallshopApi.get('/customers/me');

        updateCustomerSession({ customer: data.data });
        dispatch({
            type: CUSTOMER_ME_SUCCESS,
            payload: data.data,
        });
    } catch (err) {
        console.log(err);
    }
};

// Logout (local state first; server-side revocation is best-effort)
export const logoutCustomer = () => async (dispatch) => {
    const session = getCustomerSession();

    clearCustomerSession();
    dispatch({ type: CUSTOMER_LOGOUT });

    if (session && session.refreshToken) {
        try {
            await videocallshopApi.post('/auth/customer/logout', {
                refreshToken: session.refreshToken,
            });
        } catch (err) {
            console.log(err);
        }
    }
};

export const customerSessionExpired = () => (dispatch) => {
    dispatch({ type: CUSTOMER_LOGOUT });
};

// Account deletion (revokes Apple tokens server-side, scrubs PII)
export const deleteCustomerAccount = () => async (dispatch) => {
    try {
        await videocallshopApi.delete('/customers/me');

        clearCustomerSession();
        dispatch({ type: CUSTOMER_LOGOUT });
        toastr.success('Cuenta eliminada', 'Tu cuenta fue eliminada.');
    } catch (err) {
        toastr.error('Error', 'No se pudo eliminar la cuenta.');
    }
};

// History
export const fetchMyCallRequests = () => async (dispatch) => {
    dispatch({ type: CUSTOMER_CALL_REQUESTS_FETCH_REQUESTED });

    try {
        const { data } = await videocallshopApi.get(
            '/customers/me/call-requests'
        );

        dispatch({
            type: CUSTOMER_CALL_REQUESTS_FETCH_SUCCESS,
            payload: data.data,
        });
    } catch (err) {
        dispatch({ type: CUSTOMER_CALL_REQUESTS_FETCH_FAILED });
        toastr.error('Error', 'No se pudieron cargar tus videollamadas.');
    }
};

export const fetchMyPurchaseOrders = () => async (dispatch) => {
    dispatch({ type: CUSTOMER_PURCHASE_ORDERS_FETCH_REQUESTED });

    try {
        const { data } = await videocallshopApi.get(
            '/customers/me/purchase-orders'
        );

        dispatch({
            type: CUSTOMER_PURCHASE_ORDERS_FETCH_SUCCESS,
            payload: data.data,
        });
    } catch (err) {
        dispatch({ type: CUSTOMER_PURCHASE_ORDERS_FETCH_FAILED });
        toastr.error('Error', 'No se pudieron cargar tus órdenes.');
    }
};
